// test965
(965 && 0);
